/* eslint-disable */
import * as React from 'react'
import { useState, useEffect } from 'react'

import './App.css';
import { Routes, Route, useNavigate } from 'react-router-dom';
import MainMenu from './components/react/MainMenu/MainMenu';
import Join from './components/react/Join/Join';
import Settings from './components/react/Settings/Settings';
import CallView from './components/react/CallView/CallView';
import { DEFAULT_ROOM_ID, JOIN_ROOM_URL_INFIX } from './utils/constants';

const App: React.FC = () => {
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState<string | undefined>();

  useEffect(() => {
    document.title = 'Digital Den';
  }, [])

  const navigateToScene = async (roomUrl?: string) => {
    setRoomId(roomUrl);
    const callViewUrl = roomUrl ? `${JOIN_ROOM_URL_INFIX}${roomUrl}` : `/room`;
    navigate(callViewUrl);
  }

  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<MainMenu />} />
        <Route path="/join" element={<Join onJoin={navigateToScene} />} />
        <Route path="/room" element={<CallView renderer={'BabylonJS'} />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/r3f" element={<CallView renderer={'R3F'}/>} />
      </Routes>
    </div>
  )
}

export default App;